import { render, staticRenderFns } from "./TA7.vue?vue&type=template&id=3625a248&"
import script from "./TA7.vue?vue&type=script&lang=js&"
export * from "./TA7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports